<template>
  <div class="card">
    <div class="card-body py-0 pos-relative">
      <div class="mt-2 py-2" v-html="$t('latest_pro_releases')"></div>
      <hr class="mt-0 mb-0"/>
      <div v-if="loading" class="text-center text-muted p-3">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
      <div class="owl-carousel carousel-slider-top">
        <div class="clearfix py-3" v-for="(release, index) in topReleases" :key="`latest_pro_${index}`" @click="proArtistClicked()">
          <a :href="`https://indfy.me/${release.key}`" target="_blank" class="pull-left d-inline" style="width: 30%;">
            <img :src="release.cover_image_small || release.cover_image" :alt="release.title" class="img img-fluid" onerror="this.src = '/static/img/img-placeholder.jpg'">
          </a>
          <div class="pull-left ml-2" style="max-width: 65%; overflow-wrap: break-word;">
            <div>
              <a :href="`https://indfy.me/${release.key}`" target="_blank" class="text-primary">
                <img :src="`/static/img/countries/${release.user.country || 'default'}.png`" width="18" class="mr-1" onerror="this.src = '/static/img/img-placeholder.jpg'"> {{ release.title | truncate(25) }}
              </a>
            </div>
            <div>
              <a :href="`https://indiefy.me/${release.artist.key}`" target="_blank" class="text-black">
                {{ release.artist.name | truncate(25) }}
              </a>
            </div>
            <div class="text-muted small">{{ release.main_genre }}</div>
          </div>
        </div>
      </div>
      <div class="carousel-arrows" v-show="!loading">
        <div class="pull-left ml-1">
          <a href="javascript:void(0)" ref="prevButton">
            <i class="fa fa-chevron-left fa-2x text-muted"></i>
          </a>
        </div>
        <div class="pull-right mr-1">
          <a href="javascript:void(0)" ref="nextButton">
            <i class="fa fa-chevron-right fa-2x text-muted"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from '../components/utils/filters'
import Public from '../services/public'

export default {
  name: 'LatestPro',
  data: function () {
    return {
      loading: true,
      user: {},
      topReleases: []
    }
  },
  methods: {
    proArtistClicked: function () {
      window.gtag && window.gtag('event', 'PRO Release Click', {
        hitType: 'event',
        event_category: 'Dashboard',
        event_label: 'PRO Release Click'
      })
    },
    initTopCarousel: function () {
      this.loading = false

      setTimeout(() => {
        let carousel = window.$('.carousel-slider-top').owlCarousel({
          autoPlay: 1000 * 8,
          navigation: false,
          slideSpeed: 300,
          pagination: false,
          paginationSpeed: 1500,
          singleItem: true,
          items: 1,
          autoHeight: true,
          addClassActive: true,
          goToFirst: true,
          goToFirstSpeed: 200
        })

        window.$(this.$refs.prevButton).click(() => {
          carousel.trigger('owl.prev')
        })

        window.$(this.$refs.nextButton).click(() => {
          carousel.trigger('owl.next')
        })
      }, 200)
    },
    getTopReleases: function () {
      this.loading = true

      Public.getLatestTOPReleases().then(response => {
        this.topReleases = response.data
        this.initTopCarousel()
      })
    }
  },
  mounted: function () {
  },
  created: function () {
    this.user = this.$user
    this.getTopReleases()
  },
  components: {
  },
  filters: {
    truncate: Filters.truncate
  }
}
</script>
<style lang="scss" scoped>
.carousel-arrows {
  position: absolute;
  top: 95px;
  left: 0;
  width: 100%;
  opacity: 0.1;
}

.carousel-slider-top img {
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/LatestProReleases.vue